import axios from "axios";
import { useFormik } from "formik";
import { Button, Col, Form, Row } from "react-bootstrap";
import * as Yup from "yup";
import { useRouter } from "next/router";

const GreenForm = () => {
  const router = useRouter();
  const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
  const formik = useFormik({
    initialValues: {
      fname: "",
      mobile: "",
      email: "",
      tower: "",
      flat: "",
    },

    validationSchema: Yup.object({
      fname: Yup.string()
        .max(15, "Must be 15 characters or less")
        .required("Please Enter Your Name"),

      email: Yup.string()
        .email("Invalid email address")
        .required("Please Enter Your Email Id"),

      mobile: Yup.string()
        .matches(phoneRegExp, "Phone number is not valid")
        .max(10, "Must be 10 characters or less")
        .required("Please Enter Your Mobile Number"),
      tower: Yup.string().required("Please fill in this field"),
      flat: Yup.string().required("Please fill in this field"),
    }),
    onSubmit: async (values, { resetForm }) => {
      const data = {
        data: {
          Name: values.fname,
          Email: values.email,
          Mobile: `${values.mobile}`,
          Tower: values.tower,
          Flat: values.flat,
        },
      };
      const config = {
        method: "post",
        url: `${process.env.NEXT_PUBLIC_BACKEND_API_URL}/api/green-habitant-registrations`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      axios(config)
        .then(function (response) {
          router.push("/thank-you");
          // console.log(JSON.stringify(response.data));
        })
        .catch(function (error) {
          console.log(error);
        });
      resetForm();
    },
  });
  return (
    <>
      <Form
        onSubmit={formik.handleSubmit}
        className="needs-validation contact-form"
        noValidate
      >
        <Row>
          <Form.Group
            as={Col}
            xs={12}
            md={6}
            className="mb-3 form-group mb-lg-0"
            controlId="fname"
          >
            <Form.Control
              type="text"
              placeholder="Name"
              name="fname"
              onChange={formik.handleChange}
              value={formik.values.fname}
            />
            {formik.touched.fname && formik.errors.fname && (
              <span className="error">{formik.errors.fname}</span>
            )}
          </Form.Group>
          <Form.Group
            as={Col}
            xs={12}
            md={6}
            className="mb-3 form-group mb-lg-0"
            controlId="email"
          >
            <Form.Control
              type="email"
              placeholder="Email"
              name="email"
              onChange={formik.handleChange}
              value={formik.values.email}
            />
            {formik.touched.email && formik.errors.email && (
              <span className="error">{formik.errors.email}</span>
            )}
          </Form.Group>
          <Form.Group
            as={Col}
            xs={12}
            md={6}
            className="mb-3 form-group mb-lg-0"
            controlId="phone"
          >
            <Form.Control
              name="mobile"
              type="number"
              placeholder="Mobile"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.mobile}
            />
            {formik.touched.mobile && formik.errors.mobile && (
              <span className="error">{formik.errors.mobile}</span>
            )}
          </Form.Group>
          <Form.Group
            as={Col}
            xs={12}
            md={6}
            className="mb-3 form-group mb-lg-0"
            controlId="tower"
          >
            <Form.Control
              type="text"
              placeholder="Tower"
              name="tower"
              onChange={formik.handleChange}
              value={formik.values.tower}
            />
            {formik.touched.tower && formik.errors.tower && (
              <span className="error">{formik.errors.tower}</span>
            )}
          </Form.Group>
          <Form.Group
            as={Col}
            xs={12}
            md={6}
            className="mb-3 form-group mb-lg-0"
            controlId="flat"
          >
            <Form.Control
              type="text"
              placeholder="Flat"
              name="flat"
              onChange={formik.handleChange}
              value={formik.values.flat}
            />
            {formik.touched.flat && formik.errors.flat && (
              <span className="error">{formik.errors.flat}</span>
            )}
          </Form.Group>

          <Form.Group
            as={Col}
            xs={12}
            md={3}
            className="mb-3 form-group mb-lg-0 text-end mt-0 submit-btn"
          >
            <Button type="submit">Submit</Button>
          </Form.Group>
        </Row>
      </Form>
    </>
  );
};

export default GreenForm;
